<template>
  <ion-page>
    <ion-content color="primary">
      <div v-if="!isLoading" class="ion-padding h-100 w-100 d-flex justify-space-center">
        <div
          v-if="!isLocationDisabled"
          class="content w-100 d-flex align-center justify-space-end h-100 flex-column"
        >
          <CheckSteps
            :type="'check-in'"
            :booking-id="lastBooking?.id as string"
            :user="lastBooking?.User as User"
          />
        </div>

        <div v-else class="content w-100 d-flex align-center justify-space-end h-100 flex-column">
          <RequestPermissionsPage />
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>
<script setup lang="ts">
  import { IonPage, IonContent } from '@ionic/vue';
  import { useElasticStore } from '@/stores/elastic-store';
  import { onMounted, ref } from 'vue';
  import { useToast } from '@/composables/useToast';
  import { useBookingStore } from '@/stores/booking-store';
  import { storeToRefs } from 'pinia';
  import { useCheckInStore } from '@/stores/checkin-store';
  import CheckSteps from '@/components/check/CheckSteps.vue';
  import { getCurrentPosition } from '@/plugins/geolocalization';
  import RequestPermissionsPage from '@/components/check/RequestPermissionsPage.vue';
  import { User } from '@/interfaces/auth/auth-store.interface';
  import { useRoute } from 'vue-router';

  const route = useRoute();
  const { lastBooking } = storeToRefs(useBookingStore());
  const { rentalUnit, coords } = storeToRefs(useCheckInStore());
  const { getRentalUnitPreview } = useElasticStore();
  const { getQuestions } = useCheckInStore();
  const { showToast } = useToast();
  const { getBooking } = useBookingStore();

  const isLoading = ref(true);
  const isLocationDisabled = ref(false);

  const handleGetRentalPreview = async (id: string) => {
    try {
      const response = await getRentalUnitPreview(id);
      if (response.id) {
        rentalUnit.value = response;
      }
    } catch (error) {
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    }
  };

  const handleGetBooking = async (bookingId: string) => {
    try {
      const response = await getBooking(bookingId);
      if (response) {
        await handleGetRentalPreview(response.RentalUnit?.publicId as string);
      }
    } catch (error) {
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    }
  };

  const initialConfig = async () => {
    isLoading.value = true;
    await handleGetBooking(route.params.bookingId as string);
    await getQuestions();
    isLoading.value = false;
  };

  onMounted(async () => {
    const position = await getCurrentPosition();

    if (position) {
      initialConfig();
      coords.value = position;
    } else {
      isLocationDisabled.value = true;
      isLoading.value = false;
    }
  });
</script>
<style scoped lang="scss"></style>
